import React from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";

// Config
import styles from "../../config/styles";

const useStyles = makeStyles(theme => ({
  root: {
    ...styles.mixins.sectionContainer,
    paddingTop: theme.spacing(4)
  },
  searchRow: {
    width: "100%",
    marginBottom: theme.spacing(4)
  },
  row: {
    width: "100%",
    marginBottom: theme.spacing(2)
  },
  card: {
    border: styles.values.border,
    padding: 0
  },
  cardContent: {
    padding: theme.spacing(3, 5, 0)
  },
  gridContainer: {
    marginBottom: theme.spacing(4)
  }
}));
const CasesPageLoading = () => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <div className={classes.searchRow}>
        <Skeleton animation="wave" variant="rect" width="100%" height={48} />
      </div>
      <div className={classes.row}>
        <Skeleton animation="wave" variant="text" />
      </div>
      <Grid container className={classes.gridContainer} spacing={3}>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <div className={classes.row}>
        <Skeleton animation="wave" variant="text" />
      </div>
      <Grid container className={classes.gridContainer} spacing={3}>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card elevation={0} className={classes.card}>
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={119}
            />
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
              <Skeleton animation="wave" variant="text" />
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Skeleton animation="wave" variant="text" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </section>
  );
};

export default CasesPageLoading;
